import { AdminType, APIGet, APIUrl } from "api/protocols";

export interface IGetAccommodationUnitType {
  id?: number;
  facility_id: number;
  start_date?: string;
  end_date?: string;
  with_availability?: boolean;
}

// GET Accommodation Unit Types
export async function GetAccommodationUnitTypes(params: IGetAccommodationUnitType, useGlobalLoader: boolean) {
  return await APIGet(APIUrl(AdminType.Guest, "/accommodation/unit-types"), params, useGlobalLoader);
}
